// Ornamental SVG divider — hand-crafted luxury feel
// Used between sections (cinematic + royal flourish)

export default function OrnamentDivider({ className = "", color = "#D4AF37", accent = "#A93043" }) {
  return (
    <div className={`relative w-full flex items-center justify-center py-12 ${className}`}>
      <svg
        viewBox="0 0 800 60"
        xmlns="http://www.w3.org/2000/svg"
        className="w-full max-w-2xl kh-ornament-draw"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {/* Left filigree */}
        <path
          d="M 0 30 L 280 30"
          stroke={color}
          strokeWidth="0.5"
          fill="none"
          opacity="0.5"
        />
        <path
          d="M 280 30 Q 290 20 300 30 Q 310 40 320 30"
          stroke={color}
          strokeWidth="1"
          fill="none"
        />
        {/* Center diamond + crown notch */}
        <g transform="translate(400,30)">
          <line x1="-30" y1="0" x2="-12" y2="0" stroke={color} strokeWidth="1" />
          <path d="M -8 -6 L 0 -14 L 8 -6 L 8 6 L -8 6 Z" fill="none" stroke={color} strokeWidth="1" />
          <circle cx="0" cy="0" r="1.5" fill={accent} />
          <line x1="12" y1="0" x2="30" y2="0" stroke={color} strokeWidth="1" />
        </g>
        {/* Right filigree */}
        <path
          d="M 480 30 Q 490 20 500 30 Q 510 40 520 30"
          stroke={color}
          strokeWidth="1"
          fill="none"
        />
        <path
          d="M 520 30 L 800 30"
          stroke={color}
          strokeWidth="0.5"
          fill="none"
          opacity="0.5"
        />
        {/* Small dots */}
        <circle cx="260" cy="30" r="1" fill={color} opacity="0.6" />
        <circle cx="540" cy="30" r="1" fill={color} opacity="0.6" />
      </svg>
    </div>
  );
}
